import { connect } from "react-redux";

import { setBackdrop } from "../../../actions/appEngine";
import { setCarrierSettingEditData } from "../../../actions/carrierSettings";
import { setUser } from "../../../actions/user";
import {
	createAutoAssignCarrier,
	deleteAutoAssignCarrier,
	editRule,
	generateSignedUrl,
	getAllModeLists,
	getAutoAssignCarrier,
	getClientDetails,
	getDeliveryPartners,
	optSecureShipment,
	profile,
	saveRule,
	updateAutoAssignCarrier,
	updateRule,
	uploadFiletoS3,
} from "../../../apilist";
import AddRuleForm from "../components/AddRuleForm";

const mapDispatchToProps = {
	optSecureShipment,
	setBackdrop,
	setUser,
	getAutoAssignCarrier,
	updateAutoAssignCarrier,
	createAutoAssignCarrier,
	deleteAutoAssignCarrier,
	getAllModeLists,
	generateSignedUrl,
	profile,
	uploadFiletoS3,
	getClientDetails,
	saveRule,
	getDeliveryPartners,
	updateRule,
	setCarrierSettingEditData,
	editRule,
};

const mapStateToProps = (state) => ({
	user: state.user,
	appEngine: state.appEngine,
	pickup: state.pickup,
	carrierSetting: state.carrierSetting,
});

const containerCreator = connect(mapStateToProps, mapDispatchToProps);

export const RulesContainer = containerCreator(AddRuleForm);
